<div *ngIf="viewModel$ | async as viewModel">
  <p-inplace
    closable="closable"
    closeIcon="pi pi-check"
    (onActivate)="store.dispatch(actions.inPlaceActivated())"
    (onDeactivate)="store.dispatch(actions.inPlaceDeactivated())"
  >
    <ng-template pTemplate="display">
      <span
        class="tag-container"
        *ngIf="viewModel.hasJobTags; else clickToAddTags"
      >
        <p-tag
          [rounded]="true"
          *ngFor="let tag of viewModel.readModeTags"
          [style]="{ backgroundColor: tag.color }"
          [colorForBackground]="{
            elementSelector: 'span',
            backgroundColor: tag.color,
          }"
          [value]="tag.formattedName"
        >
        </p-tag>
      </span>
    </ng-template>
    <ng-template pTemplate="content">
      <p-autoComplete
        class="fixed-width"
        styleClass="p-mr-3"
        [multiple]="true"
        [ngModel]="viewModel.editModeTags"
        [autofocus]="true"
        [completeOnFocus]="viewModel.hasDefaultTags"
        [suggestions]="viewModel.tagSuggestions"
        (completeMethod)="
          store.dispatch(
            actions.tagAutocompleteSearchFired({ query: $event.query })
          )
        "
        (onSelect)="store.dispatch(actions.tagSelected({ tag: $event.value }))"
        (onUnselect)="
          store.dispatch(actions.tagUnselected({ tag: $event.value }))
        "
        field="name"
        placeholder="Type tag category or name"
        appendTo="body"
      >
        <ng-template let-tag pTemplate="item">
          <p-tag
            [rounded]="true"
            [style]="{ backgroundColor: tag.color }"
            [colorForBackground]="{
              elementSelector: 'span',
              backgroundColor: tag.color,
            }"
            [value]="tag.formattedName"
          >
          </p-tag>
        </ng-template>
        <ng-template let-selectedTagItem pTemplate="selectedItem">
          <p-tag
            [rounded]="true"
            [style]="{ backgroundColor: selectedTagItem.color }"
            [colorForBackground]="{
              elementSelector: 'span',
              backgroundColor: selectedTagItem.color,
            }"
            [value]="selectedTagItem.formattedName"
          >
          </p-tag>
        </ng-template>
      </p-autoComplete>
    </ng-template>
  </p-inplace>
</div>

<ng-template #clickToAddTags>
  <span class="link"> + Click to add status tags </span>
</ng-template>
